import { gql } from 'graphql-request'

export default gql`
  query getMedicalEquipmentEquipments {
    applications {
      medicalEquipment {
        equipments {
          success
          equipments {
            id
            label
          }
        }
      }
    }
  }
`
